import { useParams, useNavigate } from 'react-router-dom';
import styles from './GeoCloudViewer.module.css';

const TOKEN_KEY = 'geodraft_token';

/**
 * GeoEngine viewer route (M0 harness in-app): /projects/:projectId/viewer-cloud-v2/:fileId
 *
 * Mounts the standalone GeoEngine test harness in an iframe with the session token —
 * the same shell pattern PointCloudViewer uses for the Potree viewer. Deliberately
 * minimal while the engine is in M0–M2: the harness owns navigation and its HUD;
 * this page only provides auth and a way back.
 */
export default function GeoCloudViewer() {
  const { projectId, fileId } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem(TOKEN_KEY) || '';

  const src = `/geo-viewer-test.html?fileId=${encodeURIComponent(fileId ?? '')}` +
    `&token=${encodeURIComponent(token)}`;

  return (
    <div className={styles.wrap}>
      <button
        className={styles.back}
        onClick={() => navigate(`/projects/${projectId}/point-cloud`)}
        title="Back to files"
      >
        ← Back
      </button>
      <span className={styles.badge}>GeoEngine (experimental)</span>
      <iframe key={fileId} src={src} className={styles.frame} title="GeoEngine viewer" />
    </div>
  );
}
